import { render, staticRenderFns } from "./EditableText.vue?vue&type=template&id=b94ab754&scoped=true"
import script from "./EditableText.vue?vue&type=script&lang=js"
export * from "./EditableText.vue?vue&type=script&lang=js"
import style0 from "./EditableText.vue?vue&type=style&index=0&id=b94ab754&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94ab754",
  null
  
)

export default component.exports